import { useState } from 'react'

import copy from '../../demo/fixtures/w5/copy.json'
import { Button, Card, CardHead } from '../../ui'
import { AlertList } from './AlertList'
import { MetricStrip } from './MetricStrip'
import { MonitorRulesDialog } from './MonitorRulesDialog'
import { ThresholdChart } from './ThresholdChart'
import { useW5Live } from './live'
import styles from './AnalysisPage.module.css'

export function MetricMonitorCard() {
  const live = useW5Live()
  const [rulesOpen, setRulesOpen] = useState(false)
  return (
    <>
      <Card className={styles.section} data-scope="metric-monitor">
      <CardHead
        title={copy.sections.metricMonitor}
        subtitle={`${live.monitorRules.filter((rule) => rule.on).length} 条监控规则 · ${live.alertCount} 项告警`}
        action={<Button className={styles.rulesButton} variant="link" onClick={() => setRulesOpen(true)}>{copy.sections.monitorRules}</Button>}
      />
      <MetricStrip />
      <div className={styles.metricLayout}>
        <div className={styles.charts} data-scope="metric-charts">
          <ThresholdChart chart={live.charts.cpa} days={['8月27日', '8月28日', '8月29日', '8月30日', '8月31日', '9月1日', '9月2日']} dangerStart={4} />
          <ThresholdChart chart={live.charts.freq} days={['8月27日', '8月28日', '8月29日', '8月30日', '8月31日', '9月1日', '9月2日']} dangerStart={3} />
        </div>
        <AlertList />
      </div>
      </Card>
      <MonitorRulesDialog open={rulesOpen} rules={live.monitorRules} onClose={() => setRulesOpen(false)} />
    </>
  )
}
